export const Label = ({children}) => {
    return <label className="text-lg">{children}</label>;
};
